import * as React from 'react'
import {useDebounce} from 'hooks/useDebounce'
import Image from 'next/image'
import searchImg from 'assets/blogs/search.svg'
import classes from './styles.module.css'

interface DebouncedInputProps {
  onSearch: any
  setSearchedBlogs: any
  setSearchText: any
}

export default function DebouncedInput({
  onSearch,
}: // setSearchedBlogs,
// setSearchText,
DebouncedInputProps) {
  const [searchTerm, setSearchTerm] = React.useState('')
  const debouncedSearchTerm = useDebounce(searchTerm, 2000)
  React.useEffect(
    () => {
      onSearch(debouncedSearchTerm)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedSearchTerm], // Only call effect if debounced search term changes
  )
  return (
    <div className={classes.search}>
      <Image src={searchImg} alt="" />
      <input
        style={{background: '#EBF5FE'}}
        type="text"
        placeholder="Search"
        onChange={e => setSearchTerm(e.target.value)}
      />
    </div>
  )
}
